var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import InputAudioTags from "@/components/Inputs/InputAudioTags";
import HTTP from "@/http";
import snackbarBus from "@/snackbarBus";
var DialogAddTag = (function (_super) {
    __extends(DialogAddTag, _super);
    function DialogAddTag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            tags: [],
        };
        _this.userDistinctTags = [];
        _this.userAudioTags = [];
        _this.audioTags = [];
        return _this;
    }
    DialogAddTag.prototype.addTag = function (tag) {
        if (this.form.tags.includes(tag))
            return;
        this.form.tags.push(tag);
    };
    DialogAddTag.prototype.created = function () {
        this.getUserDistinctTags();
        this.getUserAudioTags();
        this.getAudioTags();
    };
    DialogAddTag.prototype.submit = function () {
        var _this = this;
        HTTP.put("audios/" + this.audio.id + "/tags", { tags: this.form.tags })
            .then(function (response) {
            _this.$emit('input', false);
            snackbarBus.$emit("show", "Tags edited");
        })
            .catch(function (response) {
        });
    };
    DialogAddTag.prototype.getUserDistinctTags = function () {
        var _this = this;
        HTTP.get("tags", { params: { all: true, distinct: "true", createdBy: "me" } })
            .then(function (response) {
            _this.userDistinctTags = response.data;
        })
            .catch(function (response) {
        });
    };
    DialogAddTag.prototype.getUserAudioTags = function () {
        var _this = this;
        HTTP.get("tags", { params: { all: true, createdBy: "me", audioId: this.audio.id } })
            .then(function (response) {
            _this.userAudioTags = response.data;
            _this.form.tags = _this.userAudioTags;
        })
            .catch(function (response) {
        });
    };
    DialogAddTag.prototype.getAudioTags = function () {
        var _this = this;
        HTTP.get("tags", {
            params: {
                all: true,
                audioId: this.audio.id,
                group_by: "tag_id",
                others_only: true,
            }
        })
            .then(function (response) {
            _this.audioTags = response.data;
        })
            .catch(function (response) {
        });
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], DialogAddTag.prototype, "audio", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], DialogAddTag.prototype, "value", void 0);
    DialogAddTag = __decorate([
        Component({
            components: {
                InputAudioTags: InputAudioTags,
            },
        })
    ], DialogAddTag);
    return DialogAddTag;
}(Vue));
export default DialogAddTag;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/DialogAddTag.vue
// module id = 214
// module chunks = 0